/**
 * Chess Square Component (CSS Theme)
 * Uses CSS classes + data-attribute selectors from chess-components.css
 * All color logic handled by CSS — no inline styles or Tailwind utilities
 */
import type { SquareProps } from "../../types";
import { PieceThemed } from "../piece";
import { SquareBase } from "./SquareBase";

export function SquareThemed(props: SquareProps) {
  const { isMyTurn, gameEnded, isAugmented } = props;

  const isInteractive = !gameEnded && (isMyTurn === undefined || isMyTurn);

  const containerClasses = isInteractive
    ? "chess-square"
    : "chess-square chess-square-disabled";

  return (
    <SquareBase
      {...props}
      renderPiece={(piece) =>
        piece && <PieceThemed piece={piece} isAugmented={isAugmented} />
      }
      className={containerClasses}
      legalMoveClassName="chess-move-dot"
    />
  );
}
